import React, { useState } from 'react'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    Button
  } from "@mui/material";
  import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useSelector} from 'react-redux'
import { useNavigate } from 'react-router-dom'

function Faq() {
    const styles = useSelector((state) => state.styles)
    const language = useSelector((state) => state.language.language)
    const navigate = useNavigate()

    const [faqs, setFaqs] = useState([
        {
            title : {
                'en' : 'Booking & Reservations',
                'zh-tw' : 'Booking & Reservations',
                'zh' : 'Booking & Reservations'
            },
            questions : [
                {
                    question : {
                        'en' : 'How many hostels does Vinga Hall have and where are they located?',
                        'zh-tw' : 'Vinga Hall有幾個宿舍？地點在哪裡？',
                        'zh' : 'Vinga Hall有几个宿舍？地点在哪里？'
                    },
                    answer : {
                        'en' : 'VingaHall@RG：No.99 Rangoon Road, Singapore 218384, VingaHall@BK：10/12 Beng Wan Road, Singapore 339842',
                        'zh-tw' : '我們目前在新加坡營運兩個學生宿舍：<br/> - VingaHall@RG：No.99 Rangoon Road, Singapore 218384 <br/> - VingaHall@BK：10/12 Beng Wan Road, Singapore 339842',
                        'zh' : '我们目前在新加坡营运两个学生宿舍：<br/> - VingaHall@RG：No.99 Rangoon Road, Singapore 218384 <br/> - VingaHall@BK：10/12 Beng Wan Road, Singapore 339842 '
                    }
                },
                {
                    question : {
                        'en' : 'What types of accommodation plans are available? ',
                        'zh-tw' : '宿舍提供什麼住宿方案？可以選擇是否含餐？',
                        'zh' : '宿舍提供什么住宿方案？可以选择是否含餐？'
                    },
                    answer : {
                        'en' : 'Boarding House (Meal Plan): Includes daily meals- Room For Rent (Room-Only Plan): No meals included ',
                        'zh-tw' : '我們提供兩種住宿方案：<br/> - 寄宿方案：包含每日餐食（平日供應早餐與晚餐，週末與公共假日供應三餐）。<br/> - 住宿方案：不含餐食，適合自理飲食的學生。',
                        'zh' : '我们提供两种住宿方案：<br/> - 寄宿方案：包含每日餐食（平日供应早餐与晚餐，周末与公共假日供应三餐）。<br/> - 住宿方案：不含餐食，适合自理饮食的学生。 '
                    }
                },
                {
                    question : {
                        'en' : 'What room types are available? Are en-suite bathrooms provided?',
                        'zh-tw' : 'Vinga Hall的房型有哪些？是否有獨立衛浴？',
                        'zh' : 'Vinga Hall的房型有哪些？是否有独立卫浴？'
                    },
                    answer : {
                        'en' : 'VingaHall@RG: All rooms with private bathrooms, VingaHall@BK: Some rooms with en-suite, others shared ',
                        'zh-tw' : '- VingaHall@RG：所有房型皆配備獨立衛浴，房型包含單人、雙人與三人間。<br/> - VingaHall@BK：部分房型（主人房）有獨立衛浴，其餘為共用衛浴。 ',
                        'zh' : '- VingaHall@RG：所有房型皆配备独立卫浴，房型包含单人、双人与三人间。<br/> - VingaHall@BK：部分房型（主人房）有独立卫浴，其余为共用卫浴。'
                    }
                },
                {
                    question : {
                        'en' : 'Are laundry and cleaning services included? ',
                        'zh-tw' : '宿舍是否提供洗衣、清潔等服務？',
                        'zh' : '宿舍是否提供洗衣、清洁等服务？'
                    },
                    answer : {
                        'en' : 'Yes. Bi-weekly laundry and cleaning, pocket money and wake-up call support, tutoring & counseling ',
                        'zh-tw' : '是的，所有宿舍皆提供以下「一站式管家服務」：<br/>- 每週兩次洗衣與清潔服務<br/>- 零用錢管理、叫醒服務<br/>- 生活與心理輔導、升學規劃與補習協助 ',
                        'zh' : '是的，所有宿舍皆提供以下「一站式管家服务」：<br/>- 每周两次洗衣与清洁服务<br/>- 零用钱管理、叫醒服务<br/>- 生活与心理辅导、升学规划与补习协助 '
                    }
                },
                {
                    question : {
                        'en' : 'Is transportation convenient? ',
                        'zh-tw' : '交通是否便利？距離地鐵站多遠？',
                        'zh' : '交通是否便利？距离地铁站多远？ '
                    },
                    answer : {
                        'en' : 'VingaHall@RG: 1-minute walk to Farrer Park MRT, VingaHall@BK: 7-minute walk to Boon Keng MRT',
                        'zh-tw' : '- VingaHall@RG：步行約1分鐘即可抵達花拉公園地鐵站。<br/>- VingaHall@BK：步行約7分鐘抵達文慶地鐵站。 ',
                        'zh' : '- VingaHall@RG：步行约1分钟即可抵达花拉公园地铁站。<br/>- VingaHall@BK：步行约7分钟抵达文庆地铁站。 '
                    }
                },
                {
                    question : {
                        'en' : 'How can I book a room?',
                        'zh-tw' : '我該怎麼預訂宿舍？有什麼流程？',
                        'zh' : '我该怎么预订宿舍？有什么流程？ '
                    },
                    answer : {
                        'en' : `Use the 'Hostel Application' form on our website. We’ll contact you within 1–2 business days. `,
                        'zh-tw' : '您可以透過官網「宿舍申請」功能預訂，填寫資料後我們將於1-2個工作日內聯絡您確認。 ',
                        'zh' : '您可以透过官网「宿舍申请」功能预订，填写资料后我们将于1-2个工作日内联络您确认。 '
                    }
                },
                {
                    question : {
                        'en' : 'Do I need to pay a deposit when booking?',
                        'zh-tw' : '預訂時需要支付訂金嗎？',
                        'zh' : '预订时需要支付订金吗？'
                    },
                    answer : {
                        'en' : 'Yes, a deposit is required to confirm your booking.',
                        'zh-tw' : '是的，確認房型後需事先支付訂金以保留房間。 ',
                        'zh' : '是的，确认房型后需事先支付订金以保留房间。 '
                    }
                },
                {
                    question : {
                        'en' : 'What payment methods do you accept?',
                        'zh-tw' : '可以使用什麼方式付款？有支援線上付款嗎？',
                        'zh' : '可以使用什么方式付款？有支援线上付款吗？'
                    },
                    answer : {
                        'en' : 'We support Credit Card, Bank Transfer, PayNow, international remittance, and on-site payment. ',
                        'zh-tw' : '支援信用卡、銀行轉帳、PayNow、國際匯款與現場付款，網站提供安全線上付款系統。 ',
                        'zh' : '支援信用卡、银行转帐、PayNow、国际汇款与现场付款，网站提供安全线上付款系统。'
                    }
                },
                {
                    question : {
                        'en' : 'Can I get a refund if I cancel? ',
                        'zh-tw' : '付款後可以退款嗎？有退款規則嗎？',
                        'zh' : '付款后可以退款吗？有退款规则吗？ '
                    },
                    answer : {
                        'en' : 'Once the deposit is paid, it is non-refundable in the event of cancellation. Please refer to the contract for full details of our refund policy.',
                        'zh-tw' : '入支付訂金後若取消入住，訂金將不予退還。詳細退費規則請參考我們提供的合約條款。 ',
                        'zh' : '入支付订金后若取消入住，订金将不予退还。详细退费规则请参考我们提供的合约条款。 '
                    }
                },
                {
                    question : {
                        'en' : `How long will my booking be held if I haven't paid yet?`,
                        'zh-tw' : '我已經預訂但還沒付款，房間會保留多久？',
                        'zh' : '我已经预订但还没付款，房间会保留多久？'
                    },
                    answer : {
                        'en' : 'Bed spaces are not reserved until the deposit is received. We recommend completing the payment as soon as possible to secure your booking.',
                        'zh-tw' : '尚未支付訂金前，床位將不予保留。建議您盡快完成付款，以確保成功預訂。 ',
                        'zh' : '尚未支付订金前，床位将不予保留。建议您尽快完成付款，以确保成功预订。 '
                    }
                },
            ]
        },
        // {
        //     title : {
        //         'en' : 'Booking & Reservations',
        //         'zh-tw' : 'Booking & Reservations',
        //         'zh' : 'Booking & Reservations'
        //     },
        //     questions : [
        //         {
        //             question : {
        //                 'en' : 'How can I make a reservation?',
        //                 'zh-tw' : 'How can I make a reservation?',
        //                 'zh' : 'How can I make a reservation?'
        //             },
        //             answer : {
        //                 'en' : 'You can book directly through our website by clicking on the “Book Now” button. You can also contact us via phone or email for assistance.',
        //                 'zh-tw' : 'You can book directly through our website by clicking on the “Book Now” button. You can also contact us via phone or email for assistance.',
        //                 'zh' : 'You can book directly through our website by clicking on the “Book Now” button. You can also contact us via phone or email for assistance.'
        //             }
        //         },
        //         {
        //             question : {
        //                 'en' : 'How can I make a reservation?',
        //                 'zh-tw' : 'How can I make a reservation?',
        //                 'zh' : 'How can I make a reservation?'
        //             },
        //             answer : {
        //                 'en' : 'You can book directly through our website by clicking on the “Book Now” button. You can also contact us via phone or email for assistance.',
        //                 'zh-tw' : 'You can book directly through our website by clicking on the “Book Now” button. You can also contact us via phone or email for assistance.',
        //                 'zh' : 'You can book directly through our website by clicking on the “Book Now” button. You can also contact us via phone or email for assistance.'
        //             }
        //         }
        //     ]
        // }
    ])

  return (
    <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', flexDirection : 'column'}}>
            <Box sx={{width : {lg : '60%'}, mx : {xs : 2}}}>
            <Box sx={{mt : '60px', display : 'flex', justifyContent : 'center', flexDirection : 'column'}}>
                <Typography sx={{...styles.h3, color : '#434343', textAlign : 'center'}}>Frequently Asked Questions</Typography>
                <Typography sx={{fontSize : '18px', fontWeight : 400, color : '#434343', mt : '16px', textAlign : 'center'}}>We’ve compiled the most frequently asked questions to help you feel confident about staying with us.</Typography>
            </Box>

            <Box sx={{mt : '40px'}}>
            {faqs.map((faq, i) => (
                    <Box key={i} mb={'40px'}>
                        <Box sx={{height : '60px', border : '1px solid #f5f5f5', display : 'flex', justifyContent : 'start', alignItems : 'center'}}>
                        <Typography sx={{fontSize : '18px', fontWeight : 700, color : '#434343', pl : 2}}>
                        {faq.title[language]}
                        </Typography>
                        </Box>

                        <Box>
                        {faq.questions.map((ques, index) => (
                            <Accordion key={index}>
                            <AccordionSummary sx={{height : '60px'}} expandIcon={<ExpandMoreIcon />}>
                                <Typography sx={{color : '#434343'}}>{ques.question[language]}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography sx={{color : '#434343'}}>
                                <div dangerouslySetInnerHTML={{ __html: ques.answer[language] }} />
                                </Typography>
                            </AccordionDetails>
                            </Accordion>
                        ))}
                        </Box>
                    </Box>
                    ))}
            </Box>

            <Box sx={{mb : '40px', display : 'flex', justifyContent : 'center', alignItems : 'center', flexDirection : 'column'}}>
                <Typography sx={{fontSize : '18px', fontWeight : 700, color : '#434343'}}>Need more help?</Typography>
                <Button onClick={() => navigate('/contact-us')}  variant='contained' sx={{width : '200px', ...styles.button, borderRadius : '12px', mt : '18px'}}>Contact Us</Button>
            </Box>
            </Box>
    </Box>
  )
}

export default Faq